/**
 * GC Captcha
 * Module for PrestaShop E-Commerce Software
 *
 * @author    Markus Engel <info@onlineshop-module.de>
 * @copyright Copyright (c) 2020, Onlineshop-Module.de
 * @license   commercial, see licence.txt
 */

$(function () {
    if (typeof captchaUrl !== 'undefined' && typeof captchaCssInfo !== 'undefined') {
        $.ajax({
            url: captchaUrl,
            type: "POST",
            data: {
                captchaCssInfo: captchaCssInfo,
                ajax: true,
                action: 'getCaptcha'
            },
            success: function success(responce) {
                responce.captcha.forEach(function (el) {
                    $(el.selector).append($(el.html));
                }); // $("#customer-form > section").append($(json.captcha));
            },
            error: function error(err) {
                console.log(err);
            }
        });
    }

    $('body').on('click', '.captcha-refresh-btn', function (e) {
        e.preventDefault();

        var img_id = $(this).attr('data-img-id');

        $.ajax({
            url: captchaUrl,
            type: "POST",
            data: {
                action: 'refreshCaptcha',
                name: $(this).data('name'),
                ajax: true
            },
            success: function success(responce) {
                $("#" + img_id).attr('src', responce.src);
            }
        });
    });

    //front-validation
    if (typeof captchaCssInfo != 'undefined') {
        $(captchaCssInfo).each(function () {
            var element = this.selector

            $(element).on('keyup', '#text-captcha', function () {
                $(element + ' div.text-captcha').removeClass('has-error')
                if ($(this).val() && !$.isNumeric($(this).val())) {
                    $(element + ' div.text-captcha').addClass('has-error')
                    $(this).val('')
                }
            });
        });
    }
});
